import {Link} from 'react-router-dom';

function Footer() {
    return(
        <div class="h-36 w-full bg-gray-400 lg:px-[15%] py-2">
            <div class="flex items-center justify-between h-full">
                <div class="flex-shrink-0 mx-4">
                    <Link to="/">
                        <img src="/rivermouth_logo.png" class="w-auto h-14" alt="Wellspring Logo"/>
                    </Link>
                </div>
                <ol class='md:flex flex-col md:items-center text-white text-center mr-4'>
                    <li>
                        <Link to="/privacy-policy">
                            <strong>Privacy Policy</strong>
                        </Link>
                    </li>
                    <li class='hidden'>
                        <Link to="/terms">
                            Terms of Use
                        </Link>
                    </li>
                </ol>
            </div>
        </div>
    );
};

export default Footer;